import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '@material-ui/core';
import { SelectFieldProps } from '../../types';

const FormNativeSelect: React.FC<SelectFieldProps> = ({
  label,
  nameField,
  props,
  rules,
  options,
}) => {
  const { control } = useFormContext();

  return (
    <>
      <Controller
        as={
          <Select native value="" id="select-destination" {...props}>
            {Object.entries(options).map(([k, v]) => {
              return (
                <option key={k} value={k} disabled={!k}>
                  {v}
                </option>
              );
            })}
          </Select>
        }
        control={control}
        defaultValue=""
        label={label}
        name={nameField}
        rules={rules}
      />
    </>
  );
};

export default FormNativeSelect;
